var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 292,
    viewBox: "0 0 354 292",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_131_2739)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 30C16 26.6863 18.6863 24 22 24H316C319.314 24 322 26.6863 322 30V262C322 265.314 319.314 268 316 268H22C18.6863 268 16 265.314 16 262V30Z",
    fill: "#26202a"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 221,
    y: 35,
    width: 94,
    height: 224,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 46,
    width: 59,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 46,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 46,
    width: 35,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 108,
    width: 35,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 170,
    width: 35,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 77,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 139,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 201,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 139,
    width: 59,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 139,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 77,
    width: 59,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 77,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 170,
    width: 59,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 170,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 108,
    width: 59,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 108,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 201,
    width: 59,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 141,
    y: 201,
    width: 68,
    height: 15,
    rx: 6,
    fill: "#D9D9D9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 242,
    r: 19,
    fill: "#D9D9D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_131_2739",
    x: 0,
    y: 0,
    width: 354,
    height: 292,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_131_2739"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_131_2739",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderBlack);
export default __webpack_public_path__ + "static/media/placeholder-black.cd92565a232375d43fb7d191277feef0.svg";
export { ForwardRef as ReactComponent };